/* @flow */
import type { Action } from './types';

export const SET_VARIANTS = 'SET_VARIANTS';

export const setVariants = (cookies: Object): Action => ({
  type: SET_VARIANTS,
  cookies
});
